function setLogoColor() {
  let currentHTMLBackgroundColor =
    document.documentElement.style.getPropertyValue("--background-palette");
  let havaianasLogoSVG = document.body.querySelector("#havaianas-logo>path");
  let rgb = currentHTMLBackgroundColor
    .match(/rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)/)
    .slice(1);
  let [r, g, b] = rgb.map((c) => {
    c = parseInt(c) / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  luminance < 0.5
    ? (havaianasLogoSVG.attributes.fill.value = "#fff")
    : (havaianasLogoSVG.attributes.fill.value = "#FB373C");
}
